export default "/assets/images/dusty-taupe.jpg?c5bb499ef2e55f8c75e2bfd42bd10111";